export const pageNames = {
  'Cash Flow Facility': 'Cash Flow Facility',
  'Fixed Term Funding': 'My Businesses'
};